import { ISupportRequestPayload } from '../api/request-config/support.api';
import * as constants from './support.constants';
import * as types from './support.types';

export const submitSupportRequest = (payload: ISupportRequestPayload): types.ISubmitSupportRequest => ({
  type: constants.SUBMIT_SUPPORT_REQUEST,
  payload,
});
